import { AnyAction, Middleware, Dispatch } from "redux";
import { IStoreState } from "../../rootReducer";
import {
  toggleOverlayMode,
  togglePreviousDetailedDemDiffVisibility,
} from "../ui/reducer";
import { userClicksSatelliteMapButton } from "../../../map/reusableLayers/WorldLayer/scenarios";
import type { IGcpAppDispatch } from "../../store";

const KEY_E = "e";
const KEY_D = "d";
// As in the GCP Request app: S switches between the satellite and the OpenStreetMap map
const KEY_S = "s";

export const hotKeyMiddleware: Middleware<Dispatch<AnyAction>, IStoreState> = (
  storeAPI,
) => {
  window.addEventListener("keyup", (event) => {
    const formElements = ["INPUT", "TEXTAREA"];

    // ignore hotkeys while typing
    if (
      event.target instanceof HTMLElement &&
      formElements.includes(event.target.tagName)
    ) {
      return;
    }

    if (event.key.toLowerCase() === KEY_E) {
      storeAPI.dispatch(toggleOverlayMode());
    }
    if (event.key.toLowerCase() === KEY_D) {
      storeAPI.dispatch(togglePreviousDetailedDemDiffVisibility());
    }
    if (event.key.toLowerCase() === KEY_S) {
      (storeAPI.dispatch as IGcpAppDispatch)(userClicksSatelliteMapButton());
    }
  });
  return (next) => (action: AnyAction) => next(action);
};
